import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiBell, FiUser, FiLogOut } from 'react-icons/fi';
import { removeToken } from '../../utils/auth';
import styles from './Topbar.module.css';

function Topbar({ user }) {
  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const handleLogout = () => {
    removeToken();
    // Force clear all auth data
    localStorage.clear();
    // Navigate to login
    navigate('/login', { replace: true });
  };

  return (
    <div className={styles.topbar}>
      <div className={styles.topbarContent}>
        <div className={styles.leftSection}>
          <h2 className={styles.pageTitle}>Dashboard</h2>
        </div>
        
        <div className={styles.rightSection}>
          <button className={styles.iconButton}>
            <FiBell />
          </button>
          
          <div className={styles.userMenu}>
            <button 
              className={styles.userButton}
              onClick={() => setDropdownOpen(!dropdownOpen)}
            >
              <FiUser />
              {user && <span className={styles.userName}>{user.email}</span>}
            </button>
            
            {dropdownOpen && (
              <div className={styles.dropdown}>
                <button 
                  className={styles.dropdownItem}
                  onClick={handleLogout}
                >
                  <FiLogOut />
                  <span>Déconnexion</span>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Topbar;
